import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import resources from '../../../services';
import Btn from '../../../ui/Btn';
import { Field } from '../../../ui/Field';
import UpdatePage from '../../../composents/UpdatePage';

const title = 'Zones';
const headers = {
	icon: 'feather icon-edit',
	title: title,
	description: 'update of zone',
	breadcrumbs: [
		{
			title: title,
			link: '/meters/zones',
		},
	],
};

export default function EditZone() {
	const [loader, setLoader] = useState(false),
		[errors, setErrors] = useState({}),
		[fail, setFail] = useState(false),
		[loading, setLoading] = useState(true),
		{ id } = useParams(),
		[data, setData] = useState({});

	async function onGet() {
		setLoading(true);
		let zone = await resources.zone
			.readOne(id)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (zone.status === 200) {
			setData(zone.data);
		} else if (zone.status === 403) {
			setFail(true);
		}

		setLoading(false);
	}

	useEffect(() => {
		onGet();
	}, []);

	/**
	 * @param {React.FormEvent<HTMLFormElement>} e
	 */
	async function onCreate(e) {
		e.preventDefault();
		let formData = new FormData(e.target);
		let object = {};
		formData.forEach((value, key) => (object[key] = value));
		setLoader(true);
		setErrors({});
		object.client = data.client;

		let res = await resources.zone
			.update(id, object)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (res.status === 200) {
			sessionStorage.setItem('success', true);
			window.location.replace('/meters/zones');
		} else if (res.status === 422) {
			setErrors(
				res.data.errors.reduce((acc, error) => {
					return { ...acc, [error.field]: error.message };
				}, {})
			);
		} else if (res.status === 403) {
			setErrors({ not_autorized: true });
		}
		setLoader(false);
	}

	return (
		<UpdatePage
			show_error={errors['not_autorized']}
			loading={loading}
			fail={fail}
			headers={headers}
		>
			<form onSubmit={onCreate}>
				<div className="row justify-content-center mt-3 mb-3">
					<div className="col-lg-6 ">
						<div className="card">
							<div className="card-header">
								<h5>Information</h5>
							</div>
							<div className="card-body">
								<Field
									name="zone"
									className="mb-3"
									error={errors['zone']}
									required
									defaultValue={data.zone}
								>
									Name
								</Field>

								<Field
									name="location"
									className="mb-3"
									error={errors['location']}
									defaultValue={data.location}
									required
								>
									Location
								</Field>


								<Field
									name="description"
									type="textarea"
									error={errors['description']}
									className="mb-3"
									defaultValue={data.description}
								>
									Note
								</Field>
								<div className="row ">
									<div className="col-lg-12">
										<div className="d-grid gap-2">
											<Btn
												class="btn waves-effect waves-light btn-primary "
												onLoad={loader}
											>
												<i className="feather icon-save"></i>{' '}
												Submit
											</Btn>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</UpdatePage>
	);
}
